import { createFileRoute } from '@tanstack/react-router'
import { Sparkles } from 'lucide-react'
import { z } from 'zod'
import { LearningScreen } from '@/screens/improve/SCR-030-learning'

export const Route = createFileRoute('/_app/w/$ws/learning')({
  staticData: { screen: {"id":"SCR-030","title":"Continual learning","group":"Improve","perm":"learning.read","order":2,"description":"Changes ESM proposes from outcomes, and how each was validated.", icon: Sparkles } },
  validateSearch: z.object({ state: z.enum(['candidate', 'validated', 'failed_validation', 'promoted', 'rejected', 'rolled_back']).optional() }),
  component: LearningScreen,
})
